import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './quartal.types';

export const quartalSelectors = {
  ...generateResourceSelectors<types.IQuartal>((state) => state.resource.quartal),
};
